import React, { useEffect, useState } from 'react';
import DataTable from './DataTable';
import { TbCurrencyDong } from "react-icons/tb"
import { useSelector, useDispatch } from "react-redux"
import { deleteItem, getAllCategories, getAllProducts, updateSelectedProduct } from '../api';
import { setAllProducts } from '../context/actions/productAction';
import { alertDanger, alertNULL, alertSuccess } from '../context/actions/alertActions';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../config/firebase.config';

const DBItems = () => {
    const products = useSelector((state) => state.products)
    const dispatch = useDispatch();
    const [showEditPanel, setShowEditPanel] = useState(false)
    const [selectedProductEdit, setSelectedProductEdit] = useState([])
    const [categories, setCategories] = useState([])
    const [imageUpload, setImageUpload] = useState('')
    useEffect(() => {
        if (!products) {
            getAllProducts().then((data) => {
                dispatch(setAllProducts(data));
            });
        }
    }, []);

    const handleCancelClick = (e) => {
        e.preventDefault();
        setShowEditPanel(false)
    };


    const handleInputChange = (fieldName, value) => {
        setSelectedProductEdit({
            ...selectedProductEdit,
            [fieldName]: value,
        });
        console.log(selectedProductEdit)
    };

    const handleFileChange = (e) => {
        setImageUpload(e.target.files[0])
        if (e.target.files[0]) {
            handleInputChange('imageURL', URL.createObjectURL(e.target.files[0]))

        }
    }
    const uploadImage = () => {
        return new Promise((resolve, reject) => {
            if (imageUpload) {
                const storageRef = ref(storage, `Images/${Date.now()}_${imageUpload.name}`);
                const uploadTask = uploadBytesResumable(storageRef, imageUpload);

                uploadTask.on('state_changed', (snapshot) => { },
                    (error) => {
                        dispatch(alertDanger(`Lỗi : ${error}`));
                        setTimeout(() => {
                            dispatch(alertNULL());
                        }, 3000);
                        reject(error);
                    },
                    () => {
                        getDownloadURL(uploadTask.snapshot.ref)
                            .then((downloadURL) => {
                                console.log('Downloaded URL:', downloadURL);
                                resolve(downloadURL); // Resolve with the downloadURL
                            })
                            .catch((error) => {
                                console.error('Error getting download URL:', error);
                                dispatch(alertDanger(`Lỗi : ${error}`));
                                setTimeout(() => {
                                    dispatch(alertNULL());
                                }, 3000);
                                reject(error);
                            });
                    }
                );
            } else {
                resolve(); // Resolve immediately if no image to upload
            }
        });
    };

    const handleSaveClick = async (e) => {
        e.preventDefault();
        try {
            const downloadURL = await uploadImage();

            // Update 'imageURL' in selectedProductEdit with the downloadURL
            const updatedProductEdit = {
                ...selectedProductEdit,
                imageURL: downloadURL
            };
            // After the image upload is complete, update the selected product
            const updateResult = await updateSelectedProduct(updatedProductEdit);

            // Handle the update result if needed
            console.log('Update Result:', updateResult);
            
            // Dispatch success alert and reset selected product after update
            dispatch(alertSuccess("Chỉnh sửa sản phẩm thành công"));
            setTimeout(() => {
                dispatch(alertNULL());
            }, 3000);
            setSelectedProductEdit([]);
        } catch (error) {
            // Handle errors, such as failed image upload or update
            console.error('Error during save:', error);
            // Dispatch an error alert if needed
        }
    };


    useEffect(() => {
        getAllCategories()
            .then((categories) => {
                setCategories(categories.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    return (
        <>
            <div className='flex items-center justify-self-center gap-4 pt-6 w-full relative' >
                <DataTable
                    columns={[
                        {
                            title: "Image", field: "imageURL", render: (rowData) => (
                                <img
                                    src={rowData.imageURL}
                                    className='w-32 h-16 object-contain rounded-md'
                                />
                            ),
                        }, {
                            title: "name",
                            field: "product_name"
                        }, {
                            title: "Id",
                            field: "product_id"
                        }, {
                            title: "Category",
                            field: "product_category"
                        }, {
                            title: "Price",
                            field: "product_price",
                            render: (rowData) => (
                                <p className='flex items-center justify-center text-xl font-semibold text-textColor'>
                                    {parseFloat(rowData.product_price).toLocaleString('en-US')}
                                    <TbCurrencyDong className='text-red-400' />
                                </p>
                            )
                        }
                    ]}
                    data={!products ? [] : products}
                    title="Các sản phẩm"
                    actions={[
                        {
                            icon: "edit",
                            tooltip: "Edit Data",
                            onClick: (event, rowData) => {
                                setShowEditPanel(true)
                                setSelectedProductEdit(rowData)
                            }
                        },
                        {
                            icon: "delete",
                            tooltip: "Delete Data",
                            onClick: (event, rowData) => {
                                if (window.confirm("Bạn có chắc chắn muốn xoá sản phẩm ?")) {
                                    deleteItem(rowData.product_id)
                                        .then(() => {
                                            dispatch(alertSuccess(`Delete Item ID : ${rowData.product_id} : ${rowData.product_name} successful`));
                                            getAllProducts().then((data) => {
                                                dispatch(setAllProducts(data));
                                            });
                                            setTimeout(() => {
                                                dispatch(alertNULL());
                                            }, 3000);
                                        })
                                        .catch((error) => {
                                            console.error("Error deleting item:", error);
                                        });
                                }
                            }
                        }
                    ]}
                />
            </div>
            {showEditPanel && (
                <>
                    <div className='w-full h-full z-[1000] flex justify-center items-center relative'>
                        <div className='bg-white border-slate-950 border-[1px] text-black w-[700px] h-[80%] fixed overflow-scroll'>
                            <div className='p-4 bg-red-500 text-white absolute top-0 right-0 cursor-pointer select-none'
                                onClick={() => setShowEditPanel(false)}>
                                X
                            </div>
                            <div className='p-4'>
                                <div class="flex items-center justify-center p-12">
                                    <div class="mx-auto w-full max-w-[550px] bg-white">
                                        <form className="">
                                            <div className="mb-4">
                                                <label htmlFor="product_name" className="block text-gray-700 font-semibold mb-2">Tên sản phẩm:</label>
                                                <input
                                                    type="text"
                                                    id="product_name"
                                                    name="product_name"
                                                    value={selectedProductEdit.product_name}
                                                    onChange={(e) => handleInputChange('product_name', e.target.value)}
                                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
                                                />
                                            </div>
                                            <div className="mb-4 text-sm text-gray-500">
                                                <label htmlFor="product_id" className="block font-semibold mb-2">ID sản phẩm:</label>
                                                <input
                                                    type="text"
                                                    id="product_id"
                                                    name="product_id"
                                                    value={selectedProductEdit.product_id}
                                                    readOnly
                                                    className="w-full px-3 py-2 border rounded-md bg-gray-100 cursor-not-allowed"
                                                />
                                            </div>
                                            <div className="mb-4">
                                                <label htmlFor="imageURL" className="block text-gray-700 font-semibold mb-2">Hình ảnh:</label>
                                                <div className='flex items-center'>
                                                    <img className='w-40 h-40 object-cover rounded-md mb-2' src={selectedProductEdit.imageURL} alt="" />
                                                    <label className='p-2 bg-slate-500 hover:bg-orange-600 transform transition-transform duration-300 ease-in-out text-white py-2 px-4 rounded cursor-pointer scale-100 select-none active:scale-95'>
                                                        Thay Đổi hình ảnh
                                                        <input
                                                            type="file"
                                                            className="hidden"
                                                            onChange={(e) => handleFileChange(e)}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="mb-4">
                                                <label htmlFor="product_price" className="block text-gray-700 font-semibold mb-2">Giá sản phẩm:</label>
                                                <input
                                                    type="text"
                                                    id="product_price"
                                                    name="product_price"
                                                    value={selectedProductEdit.product_price}
                                                    onChange={(e) => handleInputChange('product_price', e.target.value)}
                                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
                                                />
                                            </div>
                                            <div className="mb-4 text-sm text-gray-500">
                                                <label htmlFor="product_category" className="block font-semibold mb-2">Loại sản phẩm:</label>
                                                <select
                                                    id="product_category"
                                                    name="product_category"
                                                    value={selectedProductEdit.product_category}
                                                    onChange={(e) => handleInputChange('product_category', e.target.value)}
                                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:border-blue-500"
                                                >
                                                    {categories.map((category, index) => (
                                                        <option key={`categories_${index}`} value={category.name}>
                                                            {category.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="flex space-x-4">
                                                <button onClick={handleSaveClick} className="flex-1 bg-blue-500 text-white py-2 px-4 rounded focus:outline-none hover:bg-blue-600">
                                                    Lưu thay đổi
                                                </button>
                                                <button onClick={handleCancelClick} className="flex-1 bg-gray-500 text-white py-2 px-4 rounded focus:outline-none hover:bg-gray-600">
                                                    Huỷ thay đổi
                                                </button>
                                            </div>
                                        </form>

                                        {/* <div class="mb-5">
                                                <label
                                                    for="email"
                                                    class="mb-3 block text-base font-medium text-[#07074D]"
                                                >
                                                    Send files to this email:
                                                </label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    id="email"
                                                    placeholder="example@domain.com"
                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                                />
                                            </div> */}
                                        <div>
                                            {/* <button
                                                    class="hover:shadow-form w-full rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
                                                >
                                                    Send File
                                                </button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default DBItems